export const getQueryString = (name) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r !=null ) {
    return unescape(r[2]);
  }
  return  null;
};

export const getCookieByName = (name) => {
  const cookie = document.cookie;
  let result;
  cookie.split('; ').forEach((item) => {
    if (item.split('=')[0] === name) {
      result = item.split('=')[1];
    }
  });
  return result;
};
